import * as React from 'react';
import { ComboBox, ListItemProps, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../services/api';

type Props = {
    callbackFromParent: (data: InstructorSearchResult) => void;
    className?: string;
    style?: {};
};

type State = {
    defaultValue: InstructorSearchResult | null;
    loading: boolean;
    opened: boolean;
    instructorResults: InstructorSearchResult[];
}

export interface InstructorSearchResult {
    InstructorId: number;
    Email: string;
    Default: boolean;
}

export default class InstructorComboBox extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            defaultValue: null,
            loading: false,
            opened: false,
            instructorResults: [],
        };

        this.getInstructors();
    };

    itemRender = (li: any, itemProps: ListItemProps) => {
        const itemChildren = <span style={{ fontSize: "14px", fontFamily: "Arial, Helvetica, sans-serif", whiteSpace: "nowrap", overflow: "hidden" }}>{itemProps.dataItem.Name}</span>;
        return React.cloneElement(li, li.props, itemChildren);
    }

    onChange = (event: ComboBoxChangeEvent) => {
        this.props.callbackFromParent(event.target.value);
    }

    private getInstructors() {
        fetchApi('api/Instructor/List')
            .then((data: InstructorSearchResult[]) => {

                let _defaultSelectedInstructor: InstructorSearchResult | undefined;
                const matchInstructor = data.find(x => x.Default);
                if (matchInstructor) {
                    _defaultSelectedInstructor = matchInstructor;
                }

                const localStorageInstructorId = localStorage.getItem("INSTRUCTOR_ID");
                if (localStorageInstructorId) {
                    const matchInstructor = data.find(x => x.InstructorId === parseInt(localStorageInstructorId));
                    if (matchInstructor) {
                        _defaultSelectedInstructor = matchInstructor;
                    }
                }

                this.setState({
                    defaultValue: _defaultSelectedInstructor || null,
                    instructorResults: data,
                    loading: false
                });

                if (_defaultSelectedInstructor) {
                    this.props.callbackFromParent(_defaultSelectedInstructor);
                }
            });
    }

    public render() {
        return (
            <ComboBox
                defaultValue={this.state.defaultValue}
                data={this.state.instructorResults}
                onChange={this.onChange}
                loading={this.state.loading}
                style={this.props.style}
                itemRender={this.itemRender}
                className={this.props.className}
                allowCustom={true}
                placeholder="Instructor"
                suggest={true}
                textField="Name"
            />
        );
    }
}
